import { ToastContentProps } from 'react-toastify';

import { staticLinks } from '@/config/routingLinks';

import IcClose from '@/components/Icons/form/IcClose';
import IcPaper from '@/components/Icons/header/IcPaper';

import styles from './CookieMessage.module.scss';

export const COOKIE_CONSENT_STORAGE_KEY = 'cookie-consent-dismissed';

const CookieMessage = ({ closeToast }: Partial<ToastContentProps>) => {
  const onMessageClose = () => {
    try {
      localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, '1');
    } catch {
      // ignore storage errors
    }
    if (closeToast) closeToast();
  };

  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <IcPaper />
      </div>
      <div className={styles.info}>
        <h3>Политика обработки персональных данных</h3>
        <span>
          Мы обрабатываем cookie-файлы с целью персонализации сервиса и чтобы пользоваться
          веб-сайтом было удобнее. Вы можете запретить обработку cookie-файлов в настройках
          браузера. Пожалуйста, ознакомьтесь с{' '}
          <a href={staticLinks.privacyPolicyDoc} target='_blank' rel='noreferrer'>
            политикой обработки персональных данных
          </a>
          . Продолжая использовать сайт Вы даете{' '}
          <a href={staticLinks.personalDataConsentDoc} target='_blank' rel='noreferrer'>
            согласие на обработку персональных данных
          </a>
        </span>
      </div>
      <IcClose onClick={onMessageClose} className={styles.closeBtn} />
    </div>
  );
};

export default CookieMessage;
